<template>
  <div>
    <h2>{{ $t('title.mobiles') }}</h2>

    <data-table
      :model="mappedMobiles"
      :columns="['contact_name', 'personName', 'mobileGroupNames', 'controllerNames']"
      :operations="operations"
      v-loading.body="loading"
    />

    <el-dialog
      :title="$t('title.remove')"
      :visible="!!modelToDelete"
      width="30%"
      :before-close="() => { modelToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="deleteModel">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import { MOBILE_EDIT, SINGLE_MOBIL_ACCESS, RESTORE_MOBILE_ACCESS } from 'router/routes'
import findAll from 'service/findAll'

export default {
  name: 'mobile-list',
  data () {
    return {
      modelToDelete: null
    }
  },
  computed: {
    mappedMobiles () {
      return this.mobiles.map(mobile => {
        const relatedControllers = mobile.mobileAccesses
          .filter(a => a.registration_status && a.registration_status !== 'none')
          .map(a => this.switches.find(s => s.id === a.switch_id))
          .map(s => this.controllers.find(c => s && c.id === s.controller_id))
          .map(c => c ? c.name : null)

        const set = new Set(relatedControllers)
        const arr = Array.from(set)
        arr.sort()

        return {
          ...mobile,
          controllerNames: arr.join(', '),
          mobileGroupNames: mobile.mobileGroups.map(g => g.name).join(', ')
        }
      })
    },
    operations () {
      return [
        {
          label: 'edit',
          permission: 'EDIT_MOBILE',
          icon: 'edit',
          method: (mobile) => this.$router.push({ name: MOBILE_EDIT, params: { 'id': mobile.id } })
        },
        {
          label: 'single-access',
          permission: 'VIEW_SINGLE_MOBILE_ACCESSES',
          type: 'success',
          icon: 'circle-check',
          method: (mobile) => this.$router.push({ name: SINGLE_MOBIL_ACCESS, params: { 'id': mobile.id } })
        },
        {
          label: 'restore',
          permission: 'RESTORE_MOBILE_ACCESSES',
          method: (mobile) => this.$router.push({ name: RESTORE_MOBILE_ACCESS, params: { 'id': mobile.id } })
        },
        {
          label: 'delete',
          permission: 'DELETE_MOBILE',
          type: 'danger',
          icon: 'delete',
          method: (model) => (this.modelToDelete = model)
        }
      ]
    },
    loading () {
      return this.$store.getters['mobiles/loading']
    }
  },
  methods: {
    deleteModel () {
      this.$store.dispatch(`mobiles/delete`, this.modelToDelete)
      this.modelToDelete = null
    }
  },
  mixins: [
    findAll('mobiles'),
    findAll('switches'),
    findAll('controllers')
  ]
}
</script>



// WEBPACK FOOTER //
// MobileList.vue?11f6fea2